import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { SmallTagBase } from '@/components/ui/Tag/SmallTagBase';
const colors = {
    allGray: 'bg-gray-300',
    blueGray: 'bg-blue-gray-100',
    darkBlue: 'bg-blue-gray-300',
    darkGray: 'bg-gray-600',
    gray: 'bg-gray-400',
    lightBlue: 'bg-turquoise-blue-50',
    lightOrange: 'bg-orange-50',
    orange: 'bg-orange-100',
};
const textColors = {
    allGray: 'base',
    blueGray: 'white',
    darkBlue: 'white',
    darkGray: 'white',
    gray: 'white',
    lightBlue: 'base',
    lightOrange: 'secondary',
    orange: 'white',
};
const sizes = {
    md: 'w-[100px]',
    sm: 'w-[80px]',
    xs: 'w-[65px]',
};
export const SmallTagRounded = (props) => {
    const { children, className = '', color, isKanjiTopFixed, size = 'md', } = props;
    return (_jsx(SmallTagBase, Object.assign({ className: clsx(colors[color], sizes[size], className), isFullRounded: true, isKanjiTopFixed: isKanjiTopFixed, textColor: textColors[color] }, { children: children })));
};
export const smallTagRoundedColors = colors;
export const smallTagRoundedSizes = sizes;
